import { MouseEvent, useRef, useEffect, useState } from 'react';
import { copyToClipboard } from 'obt-common';
import { Button, TButtonProps } from '@spotnana/blocks/src/Button';
import { SerializedStyles } from '@emotion/react';

import { IconButton } from '@spotnana/blocks/src/IconButton';
import { copyable_text } from './styles';

type CopyableTextProps = {
  text: string;
  children?: React.ReactElement;
  css?: SerializedStyles;
  type?: 'button' | 'iconButton';
} & Omit<TButtonProps, 'children' | 'variant' | 'type' | 'color'>;

const CopyableText = ({ text, children, type = 'button', ...restProps }: CopyableTextProps) => {
  const copiedTimeout = useRef<ReturnType<typeof setTimeout>>(0 as unknown as ReturnType<typeof setTimeout>);
  const [copied, setCopied] = useState(false);

  const handleCopy = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    e.stopPropagation();
    copyToClipboard(text);

    setCopied(true);
    copiedTimeout.current = setTimeout(() => {
      setCopied(false);
    }, 2000);
  };

  useEffect(() => {
    return () => {
      if (copiedTimeout.current) {
        clearTimeout(copiedTimeout.current);
      }
    };
  }, []);

  if (type === 'iconButton') {
    return <IconButton variant="standard" onClick={handleCopy} icon={copied ? 'BookingCompleted' : 'Copy'} />;
  }

  return (
    <Button
      variant="ghost"
      size="small"
      onClick={handleCopy}
      css={[copyable_text, restProps.css]}
      endIcon={copied ? 'BookingCompleted' : 'Copy'}
      {...restProps}
    >
      {children || text}
    </Button>
  );
};

export default CopyableText;
